import * as d3 from 'd3-selection'
import stage from './stage'
import labels from './labels'

export default (selection, chart, processes, config) => {
  selection.each(function () {
    let container = d3.select(this)
                      .selectAll('g.process-container')
                      .data(processes)

    container.exit().remove()

    container = container.enter()
                         .append('g')
                         .attr('class', 'process-container')
                         .merge(d3.select(this).selectAll('.process-container'))
                         .attr('transform', d => `translate(${d.block.dimensions.x}, ${d.block.dimensions.y})`)

    let group = container.selectAll('g.stage')
                         .data(d => d.points)

    group.exit().remove()

    group = group.enter()
                 .append('g')
                 .attr('class', 'stage')
                 .on('click', function (e, d) {
                   if (!d.clickable) {
                     return
                   }
                   let range = d3.select(this.parentNode).datum().block.range
                   chart.ee.emit('chart-event', 'select:point', d, range)
                 })
                 .merge(group)
                 .attr('class', d => `stage is-deemphasizable ${d.color}`)
                 .classed('deemphasize', d => d.deemphasize)
                 .classed('is-clickable', d => d.clickable)
                 .attr('transform', d => `translate(0, ${d.offset})`)

    group.call(stage)
         .call(labels, config)
  })
}

